import {BzTagTone} from '@bringoz/ui';
import {TermsStatus} from '../models/terms-version.model';

export const TERMS_TABLE_UNIQUE_ID = 'terms-versions';

export const TERMS_TABLE_ROW_HEIGHT = 52;

export const TERMS_LIST_PAGE_SIZE = 50;

/**
 * Initial width of every column, keyed by the `col-*` class the header and row cells in
 * terms-view.html carry. `col-name` and `col-actions` are pinned left / right by the column manager.
 */
export const TERMS_TABLE_COLUMN_WIDTHS: Record<string, number> = {
  'col-name': 220,
  'col-version': 90,
  'col-status': 120,
  'col-created-at': 150,
  'col-updated-at': 150,
  'col-published-at': 150,
  'col-published-by': 160,
  'col-actions': 200
};

export const TERMS_STATUS_TONE: Record<TermsStatus, BzTagTone> = {
  [TermsStatus.Draft]: 'info',
  [TermsStatus.Published]: 'success',
  [TermsStatus.Archived]: 'neutral'
};

export interface TermsRowActions {
  archive: boolean;
  edit: boolean;
  publish: boolean;
  approvals: boolean;
}

/** Which row actions each status offers. Duplicate is offered for every status. */
export const TERMS_ROW_ACTIONS: Record<TermsStatus, TermsRowActions> = {
  [TermsStatus.Draft]: {archive: true, edit: true, publish: true, approvals: false},
  [TermsStatus.Published]: {archive: false, edit: false, publish: false, approvals: true},
  [TermsStatus.Archived]: {archive: false, edit: false, publish: false, approvals: false}
};
